// A same-tab, five-minute copy of the already fetched home response. Credentials
// are never stored here; authentication must finish before giving it to the UI.
const KEY = 'POSTPOP_HOME_SNAPSHOT_V1';
export const HOME_FRESH_MS = 5 * 60 * 1000;
let generation = 0;
export const homeSnapshotGeneration = () => generation;
const scope = (userId, token) => {
  try {
    const claim = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return Number.isSafeInteger(userId) &&
      userId > 0 &&
      claim.userId === userId &&
      Number.isFinite(claim.exp) &&
      claim.exp * 1000 > Date.now()
      ? `${userId}:${claim.iat || 0}:${claim.exp}`
      : null;
  } catch {
    return null;
  }
};
export function clearHomeSnapshot() {
  generation++;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Optional storage. */
  }
}
export function readHomeSnapshot(
  userId,
  locale,
  token = localStorage.getItem('POSTPOP_AUTH_TOKEN'),
) {
  try {
    const identity = scope(userId, token);
    if (!identity) return undefined;
    const saved = JSON.parse(sessionStorage.getItem(KEY));
    if (
      !saved ||
      saved.scope !== identity ||
      saved.locale !== locale ||
      !Number.isFinite(saved.at) ||
      Date.now() < saved.at ||
      Date.now() - saved.at >= HOME_FRESH_MS ||
      !Array.isArray(saved.data?.albums) ||
      !Array.isArray(saved.data?.tracks)
    )
      return undefined;
    return saved;
  } catch {
    return undefined;
  }
}
export function writeHomeSnapshot(userId, locale, token, data, startedGeneration) {
  try {
    const identity = scope(userId, token);
    if (
      !identity ||
      generation !== startedGeneration ||
      token !== localStorage.getItem('POSTPOP_AUTH_TOKEN') ||
      !Array.isArray(data?.albums) ||
      !Array.isArray(data?.tracks)
    )
      return;
    sessionStorage.setItem(KEY, JSON.stringify({ scope: identity, locale, at: Date.now(), data }));
  } catch {
    /* Quota/privacy mode never blocks the original response. */
  }
}
// A successful write can change ratings, exclusions, follows or profile genres.
// Passive recommendation telemetry must not discard the snapshot on every view.
export function invalidateHomeSnapshotForResponse(response) {
  const method = response.config?.method?.toLowerCase();
  const path = response.config?.url?.split('?')[0] || '';
  if (
    ['post', 'put', 'patch', 'delete'].includes(method) &&
    !/\/search\/discovery\/events(?:\/batch)?\/?$/.test(path)
  )
    clearHomeSnapshot();
}
export function observeHomeSnapshotInvalidation(client) {
  return client.getQueryCache().subscribe((event) => {
    if (
      event.query.queryKey[0] === 'web-discovery' &&
      (event.type === 'removed' || (event.type === 'updated' && event.action.type === 'invalidate'))
    )
      clearHomeSnapshot();
  });
}
